import React, { useState } from 'react';
import useIntl from 'react-intl/src/components/useIntl';
import { Button, Form, Input } from 'semantic-ui-react';
import messages from 'src/messages';
import './ChoicesEditor.module.css';

/**
 * The list of selectable options for a choice or list field.
 *
 * Owns only the "new option" text box - the committed options are controlled
 * by the parent, which also decides what removing one means for anything
 * derived from it (a list field's default, for instance).
 */
export function ChoicesEditor({
  choices,
  onChange,
}: {
  choices: string[];
  onChange: (next: string[]) => void;
}) {
  const { formatMessage } = useIntl();
  const [newChoice, setNewChoice] = useState('');

  const addChoice = () => {
    if (newChoice && !choices.includes(newChoice)) {
      onChange([...choices, newChoice]);
      setNewChoice('');
    }
  };

  const removeChoice = (index: number) =>
    onChange(choices.filter((_, i) => i !== index));

  return (
    <Form.Field>
      <label>{formatMessage(messages.customFieldChoices)}</label>
      <div className="choices-editor-box">
        {choices.map((choice, i) => (
          <div className="choices-editor-row" key={i}>
            <span>{choice}</span>
            <Button
              icon="trash alternate"
              type="button"
              title={formatMessage(messages.delete)}
              onClick={() => removeChoice(i)}
            />
          </div>
        ))}
        <div className="choices-editor-add">
          <Input
            value={newChoice}
            onChange={(e) => setNewChoice(e.target.value)}
            placeholder={formatMessage(messages.customFieldNewOption)}
          />
          <Button
            icon="plus"
            type="button"
            title={formatMessage(messages.add)}
            onClick={addChoice}
          />
        </div>
      </div>
    </Form.Field>
  );
}
